import React, { useEffect, useState } from "react";
import "./style.css";
import "./mentorChat.css";
import Login from "./components/login/Login.jsx";
import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import Widgets from "./pages/mainPage/Widgets.jsx";
import WrittenWorks from "./pages/writtenWorks/WrittenWorks.jsx";
import { StudioFrame } from "../personal-studio-components/studio/StudioFrame.jsx";
import CalendarGraphic from "./components/calendarGraphic/CalendarGraphic.jsx";
import Synopsis from "./pages/synopsis/Synopsis.jsx";
import NotificationsSummaries from "./pages/notificationsSummaries/NotificationsSummaries.jsx";
import AcademicDebts from "./pages/academicDebts/AcademicDebts.jsx";
import { useDispatch, useSelector } from "react-redux";
import {
  contractIdAction,
  contractNumberAction,
  contractsAction,
  currentNotificationAction,
  lssBlockNotificationDataAction,
  notificationsCountAction,
  notificationsSummariesAction,
  showNotificationDetailAction,
  vuzIdAction,
} from "./redux/actions/actions.js";
import ModalNotifications from "./components/modalnotifications/ModalNotifications.jsx";
import PracticesInfo from "./pages/practicesInfo/PracticesInfo.jsx";
import signOut from "./functions/index.js";
import OralClasses from "./pages/oralClasses/OralClasses.jsx";
import LearningPlan from "./pages/learningPlan/LearningPlan.jsx";
import Payment from "./pages/payment/Payment.jsx";
import References from "./pages/references/References.jsx";
import SabbaticalModel from "./pages/sabbatical/SabbaticalModel.jsx";
import AttestationTheme from "./pages/attestationTheme/AttestationTheme.jsx";
import ModalDeadLock from "./components/modalDeadLock/ModalDeadLock.jsx";
import { SelfCheck } from "./pages/selfCheck/SelfCheck.jsx";
import ModernProfessionalDatabases from "./pages/modernProfessionalDatabases/ModernProfessionalDatabases.jsx";
import { ElectronicConsents } from "./pages/electronicConsents/ElectronicConsents.jsx";
import { Statements } from "./pages/statements/Statements.jsx";
// Ресурсы / Видеоинструкции и Методические указания и пособия
import { FileView } from "./components/fileView/FileView.jsx";
// Профиль / Учебная карточка обучающегося
import { StudentStudyCard } from "./pages/studentStudyCard/StudentStudyCard.jsx";
// Профиль / Учетные данные
import { Credentials } from "./pages/credentials/Credentials.jsx";
// Портфолио / Практики
import { Practice } from "./pages/practice/Practice.jsx";
// Акции / Пригласить друга
import { BringFriend } from "./pages/bringFriend/BringFriend.jsx";
// Консультации
import { Questions } from "./pages/questions/Questions.jsx";
// Расписаний сессий
import ExamSessionSchedule from "./pages/examSessionSchedule/examSessionSchedule.jsx";
// Примеры использования компонентов
import { SampleRouter } from "../personal-studio-components/sample/index.js";
import { StudentService } from "./components/studentService/index.js";
import { AuthorizationService } from "./components/authorizationService/index.js";
import { Config } from "../personal-studio-components/service/Config.js";
import ViewFolder from "./components/fileView/ViewFolder.jsx";
import OnlineLibs from "./pages/onlineLibs/OnlineLibs.jsx";
import Eps from "./pages/eps/Eps.jsx";
import GroupLink from "./components/groupLink/GroupLink.jsx";
// import MentorChat from "./components/mentorChat/MentorChat.js";
import MentorChat from "../personal-studio-components/component/mentorChat/MentorChat.js";

import Extauth from "./components/extauth/Extauth.jsx";
import { ErrataWidget } from "../personal-studio-components/studio/ErrataWidget.jsx";
import { Navbar } from "../personal-studio-components/studio/Navbar.jsx";
import ErrorPage from "./pages/ErrorPage/ErrorPage.jsx";
import OnlineSchedule from "./pages/onlineSchedule/OnlineSchedule.jsx";
import NotAuthorized from "./pages/notAuthorized/NotAuthorized.jsx";
/** Веб-приложение Личная студия */
const title = "ЭИОС. Личный кабинет";
document.title = title;
//
export default function App({
  appRoot,
  mentorChatApiRoot,
  signUpVideoGuide,
  notificationsArchive,
}) {
  const { access_token } = useSelector((state) => state.token);
  const { contractId } = useSelector((state) => state.contract);
  const open = useSelector((state) => state.notifications.open);
  const lssBlockNotifications = useSelector(
    (state) => state.notifications.lssBlockNotifications,
  );

  const { isDead_lock } = useSelector((state) => state.deadLock);
  const currentNotificationIndex = useSelector(
    (state) => state.notifications.currentNotificationIndex,
  );
  const [isMentorChatLoaded, setIsMentorChatLoaded] = useState();
  const [errorMessage, setErrorMessage] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const searchParams = new URLSearchParams(window.location.search);
  // console.log("window", window.location.toString());
  const urlTest = searchParams.get("url");
  let url = null;
  let reg = new RegExp(".*" + appRoot);
  if (!searchParams.get("url")) {
    url = window.location.toString().replace(reg, "").replace(/\?.*/, "");
    // console.log("после рег", url);

    url +=
      (searchParams.get("root_dir")
        ? "?root_dir=" + searchParams.get("root_dir")
        : "") +
      (searchParams.get("guid") ? "?guid=" + searchParams.get("guid") : "") +
      (searchParams.get("merge_type")
        ? "&merge_type=" + searchParams.get("merge_type")
        : "") +
      (searchParams.get("name") ? "&name=" + searchParams.get("name") : "") +
      (searchParams.get("t") ? "?t=" + searchParams.get("t") : "") +
      (searchParams.get("token") ? "?token=" + searchParams.get("token") : "") +
      (searchParams.get("l") ? "?l=" + searchParams.get("l") : "") +
      (searchParams.get("p") ? "&p=" + searchParams.get("p") : "") +
      (searchParams.get("dir") ? "&dir=" + searchParams.get("dir") : "") +
      (searchParams.get("error") ? "?error=" + searchParams.get("error") : "");
    // console.log("внутри ифа", url);
  } else {
    url = searchParams.get("url");
    // console.log("else1", url);

    url.replace(reg, "");
    url +=
      (searchParams.get("root_dir")
        ? "?root_dir=" + searchParams.get("root_dir")
        : "") +
      (searchParams.get("guid") ? "?guid=" + searchParams.get("guid") : "") +
      (searchParams.get("merge_type")
        ? "&merge_type=" + searchParams.get("merge_type")
        : "") +
      (searchParams.get("name") ? "&name=" + searchParams.get("name") : "") +
      (searchParams.get("t") ? "?t=" + searchParams.get("t") : "") +
      (searchParams.get("token") ? "?token=" + searchParams.get("token") : "") +
      (searchParams.get("l") ? "?l=" + searchParams.get("l") : "") +
      (searchParams.get("p") ? "&p=" + searchParams.get("p") : "") +
      (searchParams.get("dir") ? "&dir=" + searchParams.get("dir") : "") +
      (searchParams.get("error") ? "?error=" + searchParams.get("error") : "");

    // console.log("else2", url);
  }
  // https://uits-demo2.roweb.online/personal-studio/?url=/personal-studio/registration/?t=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJsb2dpbl9lbWFpbCI6ImFpZGFyX2RldkBtYWlsLnJ1IiwiZXhwaXJhdGlvbl9kYXRlIjoxNzI2NTczMzUwfQ.XUfCsYJPO1EaZVt8WDo6kK4sEW_7wyWlGtHC03GlASo
  // https://uits-demo2.roweb.online/personal-studio/?url=/personal-studio/view_folder?root_dir=videoinstrucions&merge_type=stage&name=%D0%A3%D0%9Ehttps://uits-demo2.roweb.online/personal-studio/?url=/personal-studio/view_folder?root_dir=videoinstrucions&merge_type=stage&name=%D0%A3%D0%9E
  // console.log("до юзеффекта", url);

  async function getStudentInfo() {
    if (access_token) {
      const request = {
        method: "post",
        path: "/student/info",
        data: {
          access_token,
        },
      };
      StudentService.send(request, (response) => {
        if (response) {
          if (!response.errors) {
            let contract = null;
            const contracts = Object.values(response.contracts);
            for (const el of contracts) {
              if (el.main_contract) {
                contract = el;
              }
            }
            contracts.sort((a, b) => a.order_num - b.order_num);
            dispatch(contractIdAction(contract.study_contract_id));
            dispatch(vuzIdAction(contract.vuz_id));
            dispatch(contractNumberAction(contract.contract_number));
            dispatch(contractsAction(contracts));
            // get_mentor_chat_token();
          } else {
            setIsMentorChatLoaded(false);
          }
          setErrorMessage(response);
        }
      });
    }
  }
  //Процедура авторизации в чате
  async function get_mentor_chat_token() {
    //console.log("GET MENTOR CHAT TOKEN");
    // TODO:
    // mentor_chat_api_root - вынести в конфиг убрать из localStorage.
    localStorage.removeItem("mentor_chat_api_root");
    fetch(mentorChatApiRoot + "/student/token/get", {
      method: "GET",
      cache: "no-cache",
      mode: "cors",
    })
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.token) {
            localStorage.setItem("mentor_chat_token", result.token);
            localStorage.setItem("mentor_chat_title", result.chat_title || "");
            localStorage.setItem("user_type", result.user_type || "student");
            setIsMentorChatLoaded(true);
          }
        },
        (error) => {
          console.log(error);
        },
      );
  }
  async function getNotificationsCount() {
    const request = {
      method: "post",
      path: "/student/portfolio/actual_notifications_summaries/count",
      data: {
        access_token,
        study_contract_id: contractId,
      },
    };
    await StudentService.send(request, (response) => {
      if (response) {
        dispatch(notificationsCountAction(response));
      }
    });
  }

  async function getNotificationsSummaries() {
    const request = {
      method: "post",
      path: "/student/portfolio/notifications_summaries",
      data: {
        access_token,
        study_contract_id: contractId,
      },
    };
    await StudentService.send(request, (response) => {
      if (response) {
        if (!response.errors) {
          const lssBlockNotificationsArr = [];
          response.rows.forEach(
            ({ lss_blocking, planning_event_id, is_event_actual }) => {
              if (lss_blocking && !is_event_actual) {
                lssBlockNotificationsArr.push({
                  planning_event_id,
                  is_event_actual,
                  lss_blocking,
                });
              }
            },
          );
          if (lssBlockNotificationsArr.length > 0) {
            console.log(lssBlockNotificationsArr);
            dispatch(lssBlockNotificationDataAction(lssBlockNotificationsArr));
          } else {
            dispatch(lssBlockNotificationDataAction(false));
          }
        }
        dispatch(notificationsSummariesAction(response));
      }
    });
  }
  async function logout() {
    const request = {
      method: "post",
      path: "/logout",
      data: {
        access_token,
      },
    };
    await AuthorizationService.send(request, (response) => {});
  }
  const handleSignOut = () => {
    logout();
    signOut(dispatch);
    dispatch(contractIdAction(null));
  };
  useEffect(() => {
    if (access_token && !searchParams.get("l")) {
      getStudentInfo();
    }
  }, [access_token]);
  useEffect(() => {
    if (contractId) {
      async function getFetchData() {
        document.cookie =
          "StudyContractID=" + contractId + ";path=/;domain=.roweb.online";
        document.cookie = "lang=ru-RU;path=/;domain=.roweb.online";
        await getNotificationsCount();
        await getNotificationsSummaries();
        await get_mentor_chat_token();
      }
      getFetchData();
    }
  }, [contractId]);
  useEffect(() => {
    let timeoutId;
    const fetchNotifications = () => {
      if (contractId && !lssBlockNotifications && access_token) {
        getNotificationsCount();
        timeoutId = setTimeout(fetchNotifications, 20000);
      }
    };
    fetchNotifications();
    return () => {
      clearTimeout(timeoutId);
    };
  }, [contractId, lssBlockNotifications, access_token]);
  useEffect(() => {
    if (lssBlockNotifications?.length > 0) {
      const currentNotificationData = lssBlockNotifications[0];
      dispatch(currentNotificationAction(currentNotificationData));
      dispatch(showNotificationDetailAction(true));
    }
  }, [lssBlockNotifications, currentNotificationIndex]);

  useEffect(() => {
    if (url && url !== "null") {
      // console.log("До", url);
      url = url.replace(appRoot, "");
      navigate(url, { replace: true });
      // console.log("после", url);
    }
  }, [url, navigate]);
  // if (searchParams.get("token")) return <Extauth appRoot={appRoot} />;
  useEffect(() => {
    if (searchParams.get("t")) {
      signOut(dispatch);
    }
  }, [searchParams.get("t")]);
  if (searchParams.get("l")) {
    return (
      <Login
        signUpVideoGuide={signUpVideoGuide}
        paramsLogin={searchParams.get("l")}
        paramsPassword={searchParams.get("p")}
      />
    );
  }
  if (!access_token && !searchParams.get("token") && !searchParams.get("l"))
    return <Login signUpVideoGuide={signUpVideoGuide} />;
  if (errorMessage && errorMessage.errors) {
    return (
      <div style={{ margin: "0 2rem" }}>
        <Navbar handleSignOut={handleSignOut} />
        <div style={{ marginTop: "2rem" }}>
          <ErrataWidget errata={errorMessage} />;
        </div>
      </div>
    );
  }
  // if (isDead_lock) {
  //   return (
  //     <StudioFrame handleSignOut={handleSignOut}>
  //       <ModalDeadLock />
  //     </StudioFrame>
  //   );
  // }

  if ((!contractId || !access_token) && searchParams.get("token")) {
    return (
      <Routes>
        <Route
          path="/external-authorization"
          element={<Extauth appRoot={appRoot} />}
        />
      </Routes>
    );
  }
  if (contractId)
    return (
      <div>
        <StudioFrame handleSignOut={handleSignOut}>
          {isDead_lock && <ModalDeadLock />}
          <Routes>
            <Route path="/" element={<Widgets />} />
            <Route
              path="/portfolio/written-works/"
              element={<WrittenWorks />}
            />
            <Route
              path="/profile/calendar-training-schedule"
              element={<CalendarGraphic />}
            />
            <Route
              path="/profile/exam-session-schedule"
              element={<ExamSessionSchedule />}
            />
            <Route path="/online-schedule" element={<OnlineSchedule />} />
            <Route path="/online-schedule" element={<OnlineSchedule />} />
            <Route path="/not_authorized" element={<NotAuthorized />} />
            <Route
              path="/profile/electronic-consents"
              element={<ElectronicConsents />}
            />
            {/* Портфолио / Практики */}
            <Route path="/portfolio/practice" element={<Practice />} />
            {/* Исправлен маршрут страницы "Профиль / Сведения о практиках" */}
            <Route path="/profile/practices-info" element={<PracticesInfo />} />
            <Route path="/portfolio/synopsis" element={<Synopsis />} />
            <Route
              path="/portfolio/notifications-summaries"
              element={
                <NotificationsSummaries
                  notificationsArchive={notificationsArchive}
                />
              }
            />
            <Route path="/profile/academic-debts" element={<AcademicDebts />} />
            <Route
              path="/profile/elective-disciplines"
              element={<Statements />}
            />
            <Route path="/portfolio/oral-classes" element={<OralClasses />} />
            <Route path="/learning-plan" element={<LearningPlan />} />
            <Route path="/payment" element={<Payment />} />
            <Route path="/applications/references" element={<References />} />
            <Route
              path="/applications/sabbatical"
              element={<SabbaticalModel />}
            />
            <Route
              path="/applications/coursework"
              element={<AttestationTheme />}
            />
            <Route path="/resources/selfcheck" element={<SelfCheck />} />
            <Route path="/resources/online-libs" element={<OnlineLibs />} />
            <Route path="/resources/eps" element={<Eps />} />
            <Route
              path="/resources/moder-professional-databases"
              element={<ModernProfessionalDatabases />}
            />
            <Route
              path="/resources/guidelines-and-manuals"
              element={
                <FileView
                  icon="folder_open"
                  title="Методические указания и пособия"
                />
              }
            />
            {/* Профиль / Учебная карточка обучающегося */}
            <Route
              path="/profile/student-study-card"
              element={<StudentStudyCard />}
            />
            {/* Профиль / Учетные данные */}
            <Route path="/profile/credentials" element={<Credentials />} />
            {/* Акции / Пригласить друга */}
            <Route path="/bring-friend" element={<BringFriend />} />
            {/* Консультации */}
            <Route path="/questions" element={<Questions />} />
            {/* Примеры использования компонентов */}
            <Route path="/sample" element={<SampleRouter />} />
            <Route path="/view_folder" element={<ViewFolder />} />
            <Route path="/external-libraries" element={<GroupLink />} />
            <Route path="/error" element={<ErrorPage />} />
            {/* <Route path="/extauth" element={<Extauth />} /> */}
          </Routes>
        </StudioFrame>
        {open && !isDead_lock && <ModalNotifications />}
        {isMentorChatLoaded && !isDead_lock && (
          <MentorChat mentorChatApiRoot={mentorChatApiRoot}></MentorChat>
        )}
      </div>
    );
}
